/**
 * ButtonLink Component
 */
import React from "react";
import type { ButtonLinkProps } from "../types";
import { filterClass } from "../../utils/class-utils";
import { getTextAlignClass, resolveHorizontalContentAlign } from "../utils/content-alignment";

export function ButtonLink(props: ButtonLinkProps) {
  const {
    label,
    href,
    isLink,
    newWindow,
    variant,
    outline,
    size,
    width,
    horizontalAlign,
    inheritedContentAlign,
    paddingClass = "py-0",
    className,
  } = props;

  // Handle isLink as either boolean or string "true"/"false"
  const isLinkStyle = isLink === true || isLink === "true";

  // Same for newWindow: Easyblocks may hand back a boolean or a string
  const opensInNewWindow = newWindow === true || newWindow === "true";
  const newWindowAttrs = opensInNewWindow
    ? {
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-describedby": "new_window_description",
      }
    : {};

  const v = variant || "primary";
  const variantClass =
    isLinkStyle ? `btn-link link-${v}` : outline ? `btn-outline-${v}` : `btn-${v}`; // e.g. btn-primary-800, btn-gray-300, ...

  const sizeClass = {
    sm: "btn-sm",
    md: "",
    lg: "btn-lg",
  }[size || "md"] || "";

  const widthClass = width === "full" ? "w-100" : "";
  const resolvedHorizontalAlignClass = getTextAlignClass(
    resolveHorizontalContentAlign(horizontalAlign, inheritedContentAlign, "center")
  );

  /**
   * ===== FRONTEND: CLASSES & STRUCTURE (EDIT HERE) =====
   * - add/modify classes here, without touching logic.
   */
  const classes = {
    root: ["btn", variantClass, sizeClass, widthClass, className].filter(Boolean).join(" ").trim(),
    container: [resolvedHorizontalAlignClass, filterClass(paddingClass)].filter(Boolean).join(" ").trim(),
  };

  const isInEditor =
    typeof window !== "undefined" &&
    typeof window.document !== "undefined" &&
    window.document.body?.classList.contains("is-easyblocks-editor");

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isInEditor) {
      e.preventDefault();
    }
  };

  return (
    <div className={classes.container}>
      <a
        href={href || "#"}
        className={classes.root}
        onClick={handleClick}
        {...newWindowAttrs}
      >
        {label || "Button"}
      </a>
    </div>
  );
}

export default ButtonLink;


